import { Button, Card, Icon, Modal, Col, Form } from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormUtils, TableComp } from 'sz-react-utils-lite'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { getFeedBacks, updateFeedback } from '../actions'

const regExpFilters = [
  'feedBack',
  'email',
  'name',
  'journalName',
  'institueName'
]

class FeedBacks extends Component {
  state = {
    open: false,
    feedbackId: ''
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }

  loadFeedBacks = params => {
    return new Promise(async resolve => {
      let { dispatch } = this.props
      let data = await dispatch(getFeedBacks({ ...params }))
      resolve(data)
    })
  }

  onEditClose = () => {
    this.setState({ open: false, feedbackId: '' })
  }

  onEditOpen = id => {
    this.setState({ open: true, feedbackId: id })
  }

  handleSubmit = e => {
    e.preventDefault()
    const { form, dispatch, onClose } = this.props

    form.validateFields(async (err, valData) => {
      if (!err) {
        let obj = {
          ...valData,
          feedbackId: this.state.feedbackId
        }
        try {
          let result = await dispatch(updateFeedback(obj))
          if (result && result.success) {
            this.onEditClose()
            form.resetFields()
            this.table.current.reload()
          }
        } catch (error) {
          console.error('Error updating feedback:', error)
        }
      }
    })
  }

  render() {
    const {
      form: { getFieldValue, getFieldDecorator, setFieldsValue }
    } = this.props

    const inputSchema = {
      fields: [
        {
          label: 'Status',
          key: 'status',
          placeholder: 'Status',
          required: true,
          type: 'select',
          options: ['Approved', 'Rejected'],
          onChange: val => setFieldsValue({ status: val }),
          itemStyle: { marginBottom: 10 }
        },
        ...(getFieldValue('status') === 'Rejected'
          ? [
            {
              key: 'reason',
              label: 'Reason',
              placeholder: 'Reason',
              required: true,
              type: 'textarea',
              itemStyle: { marginBottom: 10 }
            }
          ]
          : [])
      ]
    }

    const columns = [
      {
        title: 'Sr. No', key: '_id', sorter: true, dataIndex: 'name', width: 35, render: (item, record, index) => {
          return index + 1
        }
      },
      { title: 'Name', key: 'name', sorter: true, dataIndex: 'name', width: 130 },
      { title: 'Institute Name', key: 'instituteName', sorter: true, dataIndex: 'instituteName', width: 130 },
      { title: 'Journal Name', key: 'journalName', dataIndex: 'journalName', width: 130 },
      { title: 'Email', key: 'email', dataIndex: 'email', width: 130 },
      { title: 'FeedBack', key: 'feedBack', dataIndex: 'feedBack', width: 130 },
      {
        title: 'Status', key: 'status', dataIndex: 'status',
        width: 150,
        render: (item = 'Pending', record) => {
          console.log(item)
          return (
            <>
              {item == 'Pending' ? <label className={'label label-warning'}>{item}</label> : null}
              {item == 'Rejected' ? <div>
                <label className={'label label-danger'}>Rejected</label>
                <div style={{ fontSize: 12, marginTop: 2 }}>Reason : {record.reason}</div>
              </div> : null}
              {item == 'Approved' ? <label className={'label label-primary'}>{item}</label> : null}
            </>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        width: 50,
        render: (_, record) => {
          let { status = 'Pending' } = record
          return (
            <div>
              {status == 'Pending' ?
                <Button type='default' shape='circle' onClick={() => this.onEditOpen(record._id)}>
                  <Icon type='edit' />
                </Button> : null
              }
            </div>
          )
        }
      }
    ]

    return (
      <PageHeaderWrapper title={'All FeedBacks'}>
        <Card bordered>
          <TableComp
            ref={this.table}
            extraProps={{ scroll: { x: 1000 } }}
            columns={columns}
            apiRequest={this.loadFeedBacks}
          />
        </Card>

        {this.state.open && (
          <Modal
            width={500}
            visible={this.state.open}
            onCancel={this.onEditClose}
            title={'Change Status Of Feedback'}
            bodyStyle={{ paddingTop: 0 }}
            footer={null}>
            <Form onSubmit={this.handleSubmit}>
              <FormUtils
                inputSchema={inputSchema}
                getFieldDecorator={getFieldDecorator}
                setFieldsValue={setFieldsValue}
                formItemLayout={{
                  labelCol: { span: 12 },
                  wrapperCol: { span: 24 }
                }}
              />
              <Button type='primary' block htmlType='submit'>
                Update Status
              </Button>
            </Form>
          </Modal>
        )}
      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories
})

const mapDispatchToProps = dispatch => ({ dispatch })

// Wrap with Form.create() so form props are injected
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(FeedBacks))
